import { sanitizeRegistration } from './checkVehicle';
import { ApiError, buildDetailsUrl, detailsApiToken } from './http';
import { secureFetchJson } from '../security/secureFetch';

export interface LatvianRegCheckResponse {
  query: string;
  reg_nr: string;
  make: string | null;
  model: string | null;
  make_model: string | null;
  technical_inspection_until: string | null;
  vehicle_type: string | null;
  fuel_type: string | null;
  technical_inspection_valid: boolean | null;
  status: string | null;
  raw_fields: Record<string, string>;
  full_response: {
    source: string;
    status_code: number;
    transport: 'gateway' | 'direct';
    html: string;
  };
}

export interface DetailsApiError {
  error: string;
  code?: string;
}

export function buildLatvianRegCheckUrl(regnr: string): string {
  const cleanRegnr = sanitizeRegistration(regnr);
  if (!cleanRegnr) {
    throw new ApiError('Latvian reg check: registration number is required', 400);
  }

  // Same plumbing as /car-tax, /car-data and /auto24-price: the Vite dev proxy
  // in dev and https://details.autospy.ee in production, with query-token auth.
  return buildDetailsUrl('/latvian-reg-check', {
    regnr: cleanRegnr,
    token: detailsApiToken(),
  });
}

export async function fetchLatvianRegCheck(
  regnr: string,
  options: { signal?: AbortSignal } = {},
): Promise<LatvianRegCheckResponse> {
  const cleanRegnr = sanitizeRegistration(regnr);
  if (!cleanRegnr) {
    throw new ApiError('Latvian reg check: registration number is required', 400);
  }
  return secureFetchJson<LatvianRegCheckResponse>('/latvian-reg-check', {
    query: { regnr: cleanRegnr },
    signal: options.signal,
    timeoutMs: 30_000,
    label: 'Latvian reg check',
    legacyToken: detailsApiToken(),
  });
}
